// //src/firebase.js
import { initializeApp } from "firebase/app";
import { connectAuthEmulator } from "firebase/auth";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
  createUserWithEmailAndPassword as firebaseCreateUserWithEmailAndPassword,
  fetchSignInMethodsForEmail as firebaseFetchSignInMethodsForEmail,
  updateProfile,
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp,
  Timestamp,
  connectFirestoreEmulator, // Added for Firestore emulator
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBHZTbS1Cap2F-tNzHvU3bWA_4JMPocUFE",
  authDomain: "greenschool-work.firebaseapp.com",
  projectId: "greenschool-work",
  storageBucket: "greenschool-work.firebasestorage.app",
  messagingSenderId: "176601035852",
  appId: "1:176601035852:web:ed82b7ac63f3a74dd9b0e9",
  measurementId: "G-LFSHL3ETP4",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth and Firestore
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Connect to emulators when in development environment
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// Check if we should use emulator (from .env.local file)
const useEmulator = process.env.REACT_APP_USE_EMULATOR === "true";

if (isLocalhost && useEmulator) {
  // Connect to Firebase emulators
  console.log("💻 Using Firebase local emulators (fake data)");
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
} else if (isLocalhost) {
  console.log("🌐 Using Firebase PRODUCTION (live data) on localhost");
} else {
  console.log("🌐 Using Firebase PRODUCTION");
}

// Google login
export const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return {
      user: result.user,
      additionalUserInfo: {
        isNewUser: result._tokenResponse?.isNewUser || false,
      },
    };
  } catch (error) {
    console.error("Google login failed:", error);
    throw error;
  }
};

// Email login
export const signInWithEmailAndPassword = async (email, password) => {
  try {
    const result = await firebaseSignInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return result.user;
  } catch (error) {
    console.error("Email login failed:", error);
    throw error;
  }
};

// Register new user
export const createUserWithEmailAndPassword = async (
  email,
  password,
  displayName
) => {
  try {
    const userCredential = await firebaseCreateUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    // Update profile with display name
    await updateProfile(userCredential.user, {
      displayName: displayName,
    });

    return userCredential;
  } catch (error) {
    console.error("Registration failed:", error);
    throw error;
  }
};

// Check if email is registered
export const fetchSignInMethodsForEmail = async (email) => {
  try {
    const methods = await firebaseFetchSignInMethodsForEmail(auth, email);
    return methods;
  } catch (error) {
    console.error("Email check failed:", error);
    throw error;
  }
};

// Save user data to Firestore
export const saveUserToFirestore = async (userId, email, displayName) => {
  try {
    const userRef = doc(db, "users", userId);
    const timestamp = serverTimestamp();

    await setDoc(userRef, {
      email: email,
      displayName: displayName,
      createdAt: timestamp,
      updatedAt: timestamp,
    });

    return true;
  } catch (error) {
    console.error("Error saving user data to Firestore:", error);
    throw error;
  }
};

export {
  auth,
  db,
  storage,
  functions,
};

// import { initializeApp } from "firebase/app";
// import {
//   getAuth,
//   signInWithPopup,
//   GoogleAuthProvider,
//   signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
//   createUserWithEmailAndPassword as firebaseCreateUserWithEmailAndPassword,
//   fetchSignInMethodsForEmail as firebaseFetchSignInMethodsForEmail,
//   updateProfile
// } from 'firebase/auth';
// import {
//   getFirestore,
//   doc,
//   setDoc,
//   serverTimestamp,
//   Timestamp
// } from 'firebase/firestore';
// import { getStorage } from "firebase/storage";

// // const firebaseConfig = {
// //   apiKey: "AIzaSyA4UMD7SDH5_t7s_6cBtbyoYkiH0RR7Rqw",
// //   authDomain: "sample-a9153.firebaseapp.com",
// //   projectId: "sample-a9153",
// //   storageBucket: "sample-a9153.firebasestorage.app",
// //   messagingSenderId: "407474357230",
// //   appId: "1:407474357230:web:410d0460ddf4f74751c4ff"
// // };
// const firebaseConfig = {
//   apiKey: "AIzaSyBHZTbS1Cap2F-tNzHvU3bWA_4JMPocUFE",
//   authDomain: "greenschool-work.firebaseapp.com",
//   projectId: "greenschool-work",
//   storageBucket: "greenschool-work.firebasestorage.app",
//   messagingSenderId: "176601035852",
//   appId: "1:176601035852:web:ed82b7ac63f3a74dd9b0e9",
//   measurementId: "G-LFSHL3ETP4"
// };
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// // Initialize Auth and Firestore
// const auth = getAuth(app);
// const db = getFirestore(app);

// // 初始化 Firebase Storage
// const storage = getStorage(app);

// // Google login
// export const signInWithGoogle = async () => {
//   try {
//     const provider = new GoogleAuthProvider();
//     const result = await signInWithPopup(auth, provider);
//     return {
//       user: result.user,
//       additionalUserInfo: {
//         isNewUser: result._tokenResponse?.isNewUser || false
//       }
//     };
//   } catch (error) {
//     console.error('Google login failed:', error);
//     throw error;
//   }
// };

// // Email login
// export const signInWithEmailAndPassword = async (email, password) => {
//   try {
//     const result = await firebaseSignInWithEmailAndPassword(auth, email, password);
//     return result.user;
//   } catch (error) {
//     console.error('Email login failed:', error);
//     throw error;
//   }
// };

// // Register new user
// export const createUserWithEmailAndPassword = async (email, password, displayName) => {
//   try {
//     const userCredential = await firebaseCreateUserWithEmailAndPassword(auth, email, password);

//     // Update profile with display name
//     await updateProfile(userCredential.user, {
//       displayName: displayName
//     });

//     return userCredential;
//   } catch (error) {
//     console.error('Registration failed:', error);
//     throw error;
//   }
// };

// // Check if email is registered
// export const fetchSignInMethodsForEmail = async (email) => {
//   try {
//     const methods = await firebaseFetchSignInMethodsForEmail(auth, email);
//     return methods;
//   } catch (error) {
//     console.error('Email check failed:', error);
//     throw error;
//   }
// };

// // Save user data to Firestore
// export const saveUserToFirestore = async (userId, email, displayName) => {
//   try {
//     const userRef = doc(db, "users", userId);
//     const timestamp = serverTimestamp();

//     await setDoc(userRef, {
//       email: email,
//       displayName: displayName,
//       createdAt: timestamp,
//       updatedAt: timestamp
//     });

//     return true;
//   } catch (error) {
//     console.error("Error saving user data to Firestore:", error);
//     throw error;
//   }
// };

// export {
//   auth,
//   db,
//   storage
// };
